import { render } from "./SVGColorWall.vue?vue&type=template&id=2d71dca6"
import script from "./SVGColorWall.vue?vue&type=script&lang=js"
export * from "./SVGColorWall.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__